define("settings/routes/subscription/billing", ["exports", "@ember/routing/route", "@ember/runloop", "@ember/service", "ember-concurrency"], function (_exports, _route, _runloop, _service, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/runloop",0,"@ember/service",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let BillingRoute = (_class = class BillingRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "payment", _descriptor4, this);
    }

    async beforeModel() {
      await this.address.setup.perform();
    }

    async setupController(controller) {
      const payments = await this.payment.retrieve.perform();
      const creditCard = await this.payment.retrieveCard.perform();
      controller.setProperties({
        creditCard,
        payments,
        handleEmailReceiptsToggle: this.handleEmailReceiptsToggle
      });
    }

    *handleEmailReceiptsToggle(account) {
      const isEnabling = !account.emailReceipts;
      const messageStr = isEnabling ? 'message_enable' : 'message_disable';
      account.toggleProperty('emailReceipts');

      try {
        yield account.save();
        this.alerts.success(this.intl.t(`alerts.account.subscription.billing.email_receipt.success.${messageStr}`), {
          title: this.intl.t('alerts.account.subscription.billing.email_receipt.success.title')
        });
      } catch (error) {
        (0, _runloop.later)(() => {
          account.rollbackAttributes();
        }, 10);
        this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
          title: this.intl.t('alerts.account.subscription.billing.email_receipt.error.title')
        });
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleEmailReceiptsToggle", [_emberConcurrency.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleEmailReceiptsToggle"), _class.prototype)), _class);
  _exports.default = BillingRoute;
});